module.exports = __webpack_public_path__ + "../resources/img/ic-inverter-default.4bc93d88.svg";